import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

const RE = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;

export function GstinInput({ value, onChange, onFetched, testid }) {
  const [busy, setBusy] = useState(false);
  const fetchIt = async (g) => {
    setBusy(true);
    try {
      const { data } = await api.post("/gstin/lookup", { gstin: g });
      onFetched(data);
      toast.success(data.full ? `${data.name} — details bhar di gayi (${data.gst_status || "GST"})` : "State aur PAN bhar diya. Naam/pata ke liye GST API key jodein.");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const change = (e) => {
    const g = e.target.value.toUpperCase().replace(/\s/g, "");
    onChange(g);
    if (RE.test(g) && g !== value) fetchIt(g);
  };
  return (
    <div className="flex gap-1.5">
      <Input data-testid={testid} className="uppercase" maxLength={15} value={value || ""} onChange={change} placeholder="33AAACU1234F1Z5" />
      <button type="button" title="GSTIN se details laayein" data-testid={`${testid}-fetch`} disabled={busy || !RE.test(value || "")} onClick={() => fetchIt(value)}
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border bg-card transition-colors hover:bg-secondary disabled:opacity-40">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Search className="h-4 w-4" />}
      </button>
    </div>
  );
}

export const fillFrom = (f, d, map) => {
  const out = { ...f };
  Object.entries(map).forEach(([k, src]) => { if (d[src]) out[k] = d[src]; });
  return out;
};
